import { ContactService } from './../../../api/contact.service';
import { GtagService } from './../../../analytics/gtag.service';
import { FbqService } from './../../../analytics/fbq.service';
import { OnInit } from '@angular/core';
import { Contact, FormError } from '../../../models/index';
import { environment } from './../../../../../environments/environment';
import { AgencyService } from '../../../api/agency.service';
import { ReCaptchaComponent } from '../../../re-captcha.component';
var ContactFormBaseComponent = /** @class */ (function () {
    function ContactFormBaseComponent(contactService, gtagService, fbqService, agencyService) {
        this.contactService = contactService;
        this.gtagService = gtagService;
        this.fbqService = fbqService;
        this.agencyService = agencyService;
        this.contact = new Contact();
        this.formError = new FormError();
        this.canShowErrors = false;
    }
    Object.defineProperty(ContactFormBaseComponent.prototype, "reCaptchaVersion", {
        get: function () {
            return environment.re_captcha_version;
        },
        enumerable: true,
        configurable: true
    });
    ContactFormBaseComponent.prototype.ngOnInit = function () {
        this.success = false;
        this.submitInProgress = false;
    };
    ContactFormBaseComponent.prototype.onSubmit = function () {
        this.canShowErrors = true;
        if (this.submitInProgress || this.success)
            return;
        if (!this.contact.marketing_accepted) {
            this.formError.errors.marketing_accepted = 'pentru a trimite un mesaj, această bifă este obligatorie.';
            return;
        }
        else
            this.formError.errors.marketing_accepted = null;
        this.formError = new FormError();
        this.contact.re_captcha_version = this.reCaptchaVersion;
        this.sendMessage();
    };
    ContactFormBaseComponent.prototype.onCaptchaResponse = function (response) {
        this.contact['g-recaptcha-response'] = response;
        if (this.reCaptchaVersion === 'v2_invisible')
            this.sendMessage();
    };
    ContactFormBaseComponent.prototype.sendMessage = function () {
        var _this = this;
        var promise;
        if (this.submitInProgress)
            return;
        this.submitInProgress = true;
        var contact = JSON.parse(JSON.stringify(this.contact));
        if (this.prependMessage)
            contact.message = this.prependMessage + '\n\n\n' + (this.contact.message ? this.contact.message : '');
        if (this.propertyId) {
            promise = this.contactService.sendToProperty(this.propertyId, contact);
        }
        else if (this.projectId) {
            promise = this.contactService.sendToProject(this.projectId, contact);
        }
        else if (this.apartmentTypeId) {
            promise = this.contactService.sendToApartmentType(this.apartmentTypeId, contact);
        }
        else {
            promise = this.contactService.sendToAgency(contact);
        }
        if (promise) {
            promise
                .then(function (response) {
                _this.contact = new Contact();
                _this.submitInProgress = false;
                _this.success = true;
                _this.gtagService.sendEvent('contact', 'message_sent', 'contact_form_sent');
                _this.fbqService.sendEvent('Lead', { content_name: 'contact_form_sent', content_category: 'message_sent' });
            })
                .catch(function (reposnse) {
                _this.formError = reposnse;
                _this.submitInProgress = false;
                _this.success = false;
            });
        }
    };
    return ContactFormBaseComponent;
}());
export { ContactFormBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/contact-form-base/contact-form-base.component.ts.pre-build-optimizer.js